import { render, staticRenderFns } from "./Dynamicxq.vue?vue&type=template&id=a09f9824&scoped=true"
import script from "./Dynamicxq.vue?vue&type=script&lang=js"
export * from "./Dynamicxq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f9824",
  null
  
)

export default component.exports